import {
  ApplicationConfig,
  provideZoneChangeDetection,
  importProvidersFrom,
} from "@angular/core";
import {
  PreloadAllModules,
  provideRouter,
  RouteReuseStrategy,
  withHashLocation,
  withPreloading,
} from "@angular/router";
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { SplashScreen } from "@awesome-cordova-plugins/splash-screen/ngx";
import { StatusBar } from "@awesome-cordova-plugins/status-bar/ngx";
import { routes } from "./app-routes";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { IonicStorageModule } from "@ionic/storage-angular";
import { AuthGuardService } from "./services/auth-guard.service";
import { environment } from "../environments/environment";
import { ServiceWorkerModule } from "@angular/service-worker";
import { NetworkInterceptorModule } from "./services/network-interceptor/network-interceptor.module";
import { HeaderMenuModule } from "./components/header-menu/header-menu.module";
import { BrowserModule } from "@angular/platform-browser";
import { LhTableComponent } from "./components/lh-table/lh-table.component";
import { RouterModule } from "@angular/router";
import { Drivers } from "@ionic/storage";

// ✅ Only use AngularFire SDKs — DO NOT import from 'firebase/app'
import { provideFirebaseApp, initializeApp } from "@angular/fire/app";
import { provideAnalytics, getAnalytics } from "@angular/fire/analytics";
import {
  provideRemoteConfig,
  getRemoteConfig,
} from "@angular/fire/remote-config";

import { inject } from "@angular/core";
import { FirebaseApp } from "@angular/fire/app";

// ✅ Initialize Firebase
const firebaseApp = initializeApp(environment.firebase);
export const appConfig: ApplicationConfig = {
  providers: [
     { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      provideIonicAngular(),
      provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withHashLocation()
    ),
    importProvidersFrom(
      BrowserModule,
      RouterModule,
      HeaderMenuModule,
      BrowserAnimationsModule,
      NetworkInterceptorModule,
      IonicStorageModule.forRoot({
        name: "__carrierportal",
        driverOrder: [Drivers.IndexedDB, "sqlite", "websql"],
      }),
      ServiceWorkerModule.register("ngsw-worker.js", {
        enabled: environment.production,
      })
    ),

    // ✅ Correct: Provide AngularFireApp
    // provideFirebaseApp(() => initializeApp(environment.firebase)),
      provideFirebaseApp(() => firebaseApp),

    // ✅ Correct: Provide Analytics (AngularFire handles default app binding internally)
    provideAnalytics(() => getAnalytics()),

    // ✅ Correct: Provide Remote Config
    provideRemoteConfig(() => {
      const app = inject(FirebaseApp); // ✅ Ensures FirebaseApp is initialized
      const remoteConfig = getRemoteConfig(app);
      remoteConfig.settings = {
        minimumFetchIntervalMillis: 3600000,
        fetchTimeoutMillis: 60000,
      };
      return remoteConfig;
    }),

    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    StatusBar,
    SplashScreen,
    AuthGuardService,
    LhTableComponent,
  ],
};

